<template>
  <div :class="wrapperClass" :style="wrapperStyle" :title="teamName">
    <img
      v-if="showImage"
      :src="src"
      :alt="teamName"
      class="team-logo-image"
      @error="handleError"
    />
    <div v-else class="team-logo-fallback">
      {{ initials }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    teamName: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 56
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      failed: false
    };
  },
  computed: {
    showImage() {
      return Boolean(this.src) && !this.failed;
    },
    initials() {
      const words = String(this.teamName || '')
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2);
      if (!words.length) {
        return '?';
      }
      return words.map((word) => word[0]).join('').toUpperCase();
    },
    wrapperClass() {
      return {
        'team-logo-badge': true,
        'is-rounded': this.rounded,
      };
    },
    wrapperStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      };
    }
  },
  watch: {
    src() {
      this.failed = false;
    }
  },
  methods: {
    handleError() {
      this.failed = true;
    }
  }
};
</script>

<style scoped>
.team-logo-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 18px;
  background: linear-gradient(135deg, #f7f1e1 0%, #e4d1ae 100%);
  border: 1px solid rgba(81, 52, 24, 0.12);
}

.team-logo-badge.is-rounded {
  border-radius: 999px;
}

.team-logo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: white;
}

.team-logo-fallback {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
  color: #7a4a25;
  letter-spacing: 0.05em;
}
</style>
